import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class Form161Service {

  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }

  getCustomers() {
    return this.httpClient.get(`${this.rootUrl}/api/Form161/GetCustomers`);
  }

  GetEmployees(customerId) {
    return this.httpClient.get(`${this.rootUrl}/api/Form161/GetEmployees?customerId=${customerId}`);
  }

  GetFundInstitution(customerId, employeeId) {
    return this.httpClient.get(`${this.rootUrl}/api/Form161/GetFundInstitution?customerId=${customerId}&employeeId=${employeeId}`);
  }

  send161(customerId, employeeId, fundInstitutionId) {
    return this.httpClient.get(`${this.rootUrl}/api/Form161/Send161?customerId=${customerId}&employeeId=${employeeId}&fundInstitutionId=${fundInstitutionId}`);
  }
  
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/form161.service.ts